module.exports = __webpack_public_path__ + "media/customizations/experiencesevenoaks/back-75dd4dba6a018e2adb6d74e16293c1d1.jpg";